var _polygon, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnectedStatusIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,9 93,88 7,88",
    fill: "#8B0000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 34,
    width: 8,
    height: 24,
    fill: "white",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 63,
    width: 8,
    height: 10,
    fill: "white",
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectedStatusIconDark);
export default __webpack_public_path__ + "static/media/disconnected-status-icon-dark.a82fc5f6224c4a65f2e42f59cb02cf85.svg";
export { ForwardRef as ReactComponent };